/*  ========================================================================
    # Components - Project
    ========================================================================  */

import React from 'react';
import PropTypes from 'prop-types';
import useTranslation from '../hooks/useTranslation';
import bem from '../helpers/bem';
import tailwindConfig from '../../../tailwind.config';
import LazyImage from './LazyImage';
import LazySource from './LazySource';

const Project = ({ customer, projectName, description, image, permalink, skeleton }) => {
  const __ = useTranslation();

  return (
    <>
      {skeleton ? (
        <div className={bem('s-projects', 'project', { skeleton: true })}>
          <div
            className={`${bem(
              's-projects',
              'project-content'
            )} tw-w-full xl:tw-w-5/12 lg:tw-w-6/12`}
          >
            <p className={bem('s-projects', 'project-name')} />
            <div className={bem('s-projects', 'project-description')} />
          </div>
          <div
            className={`${bem('s-projects', 'project-image')} tw-w-full xl:tw-w-7/12 lg:tw-w-6/12`}
          />
        </div>
      ) : (
        <a
          href={permalink}
          title={`${__('projects-link-label')} ${projectName}`}
          className={bem('s-projects', 'project')}
        >
          <div
            className={`${bem(
              's-projects',
              'project-content'
            )} tw-w-full xl:tw-w-5/12 lg:tw-w-6/12`}
          >
            <h3
              className={bem('s-projects', 'project-name')}
              dangerouslySetInnerHTML={{
                __html: `${customer} <span class=${bem('s-projects', 'project-title')} >${projectName}</span>`
              }}
            />

            <div className={bem('s-projects', 'project-description')}>
              <p dangerouslySetInnerHTML={{ __html: description }} />
            </div>
            <div className={bem('c-link-with-svg', '', { 'arrow-right': true })}>
              {__('projects-link-label')}
            </div>
          </div>

          <LazyImage
            alt={image.alt}
            figureClass={`${bem(
              's-projects',
              'project-image'
            )} tw-w-full xl:tw-w-7/12 lg:tw-w-6/12`}
            defaultUrl={image.sizes.large}
            placeholderUrl={image.sizes.placeholder}
          >
            <LazySource srcSet={image.sizes.large} mediaMin={tailwindConfig.theme.screens.lg} />
            <LazySource srcSet={image.sizes.medium} mediaMin={tailwindConfig.theme.screens.md} />
          </LazyImage>
        </a>
      )}
    </>
  );
};

Project.propTypes = {
  customer: PropTypes.string,
  projectName: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.object,
  permalink: PropTypes.string,
  skeleton: PropTypes.bool
};

export default Project;
